import React from "react";
import { Grid } from "@material-ui/core";

const SolidSeparator = ({ companyPrimaryColor }) => (
  <Grid container xs={12} direction="row" style={{ backgroundColor: companyPrimaryColor, height: "10px" }} />
);

export default SolidSeparator;
